import React from 'react'
import { ReactComponent as Cross } from "../../assets/img/cross.svg"


const CustomModal = ({ handleModal, children, heading, buttonName, handleSave, loading, wide, footer, stickyFooterOnMobile }) => {
    // Wide variant bumps max-width to ~720px so dense forms (Add/Edit Product)
    // get more horizontal room. Mobile (<768px) goes near-full-screen via CSS.
    const boxClass = `modal-box${wide ? ' modal-box--wide' : ''}${stickyFooterOnMobile ? ' modal-box--sticky-footer' : ''}`;
    return (
        <div style={{ fontFamily: "Outfit", position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 1050, display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
            <div className={boxClass}
                style={{ backgroundColor: "#fff", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", padding: "30px 30px", position: "relative", maxHeight: '98vh', overflowY: 'auto', scrollbarWidth: "none" }}
            >
                <h1 style={{
                    fontWeight: 600,
                    fontSize: '24px',
                    fontFamily: "Outfit",
                    color: '#1C1C1C'
                }}>{heading}</h1>
                <div onClick={handleModal} className='vs-modal-close position-absolute' style={{
                    right: '20px',
                    top: '20px',
                }}>
                    <Cross />
                </div>
                <div className='modal-box__content'>{children}</div>
                <div className='modal-box__footer' style={{ display: "flex", justifyContent: "center", marginTop: "35px", gap: '10px' }}>
                    {footer ?? (
                        <>
                            <button
                                className='vs-btn-cancel'
                                onClick={handleModal}
                            >
                                Cancel
                            </button>
                            <button
                                disabled={loading}
                                className={`vs-btn-save ${loading ? 'disabled' : ''}`}
                                onClick={handleSave ?? handleModal}
                            >
                                {buttonName}
                            </button>
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}

export default CustomModal
